<template>
  <div class="app flex-row align-items-center background-image">
    <link
      rel="stylesheet"
      href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    />

    <div class="container">

      <!-- Logo -->
      <div class="row justify-content-center">
        <div class="col-12 text-center" style="padding-bottom: 50px;">
          <img src="favicon.png" class="centered-image" alt="Logo Inpar">
        </div>
      </div>

      <!-- Login card -->
      <div class="row justify-content-center mt-4">
        <div class="col-md-4">
          <div class="card-group mb-0">
            <div class="card p-4">
              <div class="card-body">

                <form v-on:submit="doLogin" action="#">
                  <h3>{{ appName }}</h3>
                  <p class="text-muted">
                    Bem-vindo ao {{ appName }}, para aceder à sua conta utilize o formulário abaixo.
                  </p>

                  <!-- Username -->
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-text slot="prepend">
                        <i class="fa fa-user"></i>
                      </b-input-group-text>
                      <b-form-input
                        name="username"
                        placeholder="Nome de utilizador"
                        v-model="username"
                      />
                    </b-input-group>
                  </b-form-group>

                  <!-- Password with toggle -->
                  <b-form-group>
                    <b-input-group>
                      <b-input-group-text slot="prepend">
                        <i class="fa fa-key"></i>
                      </b-input-group-text>
                      <b-form-input
                        :type="showPassword ? 'text' : 'password'"
                        placeholder="Palavra-passe"
                        v-model="password"
                      />

                      <i
                        :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"
                        @click="togglePasswordVisibility"
                        class="toggle-password"
                      ></i>
                    </b-input-group>
                  </b-form-group>

                  <div class="row">
                    <div class="col-6">
                      <router-link :to="{ name: 'SendRecovery' }">
                        Esqueceu-se da palavra-passe?
                      </router-link>
                    </div>

                    <div class="col-12 text-center">
                      <button
                        :disabled="working"
                        type="submit"
                        class="btn btn-primary btn-block"
                      >
                        Login
                      </button>
                    </div>
                  </div>

                </form>

              </div>
            </div>
          </div>

        </div>
      </div>

    </div>

  </div>
</template>

<style>
.background-image {
  background-color: #fce9d7;
  background-size: cover;
  background-position: center center;
  background-repeat: no-repeat;
  height: 100vh;
}

.btn-block {
  width: 100%;
}

.btn-primary {
  color: #fff;
  background-color: #ff5a00;
  border-color: #ff5a00;
}

.btn-primary:hover {
  color: #fff;
  background-color: #cd4800;
  border-color: #cd4800;
}

.btn-primary:disabled {
  color: #fff;
  background-color: #cd4800;
  border-color: #cd4800;
}

.centered-image {
  max-width: 125px;
  height: auto;
}

.toggle-password {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  cursor: pointer;
}
</style>

<script>
export default {
  name: 'Login',
  data() {
    return {
      appName: 'Inpar BO',
      working: false,
      username: '',
      password: '',
      showPassword: false
    }
  },

  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },

    doLogin(event) {
      this.working = true;
      event.preventDefault();

      let redirect = this.$auth.redirect();
      let redirectTo = { name: 'dashboard' };

      if (redirect) redirectTo = redirect.from;

      this.$auth.login({
        data: {
          username: this.username,
          password: this.password
        },
        redirect: redirectTo,
        success: function() {
          this.$bvToast.toast(`Login efetuado com sucesso`, {
            autoHideDelay: 5000,
            variant: 'success',
            solid: true
          });
        },
        error: function() {
          this.working = false;
          this.$bvToast.toast(`Nome de utilizador ou palavra-passe incorrectos`, {
            autoHideDelay: 5000,
            variant: 'danger',
            solid: true
          });
        }
      });
    }
  },

  created() {
    if (typeof Window.appConfig !== 'undefined' && Window.appConfig.name) {
      this.appName = Window.appConfig.name;
    }
  }
}
</script>